import { LiveNewsDTO, } from "../../../../domains/features/LiveNews/dto/LiveNewsDTO";
import urlConfig from "@adapters/infrastructures/urlConfig/homeUrl";
export default class LiveNewsRepository {
    constructor(http) {
        this.http = http;
    }
    async getLiveNewsData(requestData) {
        const liveNewsData = await this.http.makeApiCall({
            method: "POST",
            url: requestData.segmentType ? urlConfig.liveNewsNFOUrl : urlConfig.liveNewsUrl,
            body: {
                exclCategory: (requestData === null || requestData === void 0 ? void 0 : requestData.exclCategory)
                    ? requestData.exclCategory
                    : ["Global"],
                validRequest: false,
                inclCategory: (requestData === null || requestData === void 0 ? void 0 : requestData.inclCategory) ? requestData.inclCategory : [],
                page: requestData === null || requestData === void 0 ? void 0 : requestData.page,
                group: "NG",
                searchText: requestData === null || requestData === void 0 ? void 0 : requestData.searchText,
                dateTime: (requestData === null || requestData === void 0 ? void 0 : requestData.page) && (requestData === null || requestData === void 0 ? void 0 : requestData.page) > 0 ? new Date() : "",
                segmentType: requestData === null || requestData === void 0 ? void 0 : requestData.segmentType
            },
        });
        let liveNewsDataList = LiveNewsDTO(liveNewsData.data.listResponse);
        return liveNewsDataList;
    }
    async getEquityHoldingLiveNews(requestData) {
        const liveNewsData = await this.http.makeApiCall({
            method: "POST",
            url: urlConfig.equityHoldingLiveNews,
            body: {
                exclCategory: (requestData === null || requestData === void 0 ? void 0 : requestData.exclCategory)
                    ? requestData.exclCategory
                    : ["Global"],
                validRequest: false,
                inclCategory: (requestData === null || requestData === void 0 ? void 0 : requestData.inclCategory) ? requestData.inclCategory : [],
                page: requestData === null || requestData === void 0 ? void 0 : requestData.page,
                group: "NG",
                searchText: requestData === null || requestData === void 0 ? void 0 : requestData.searchText,
                dateTime: (requestData === null || requestData === void 0 ? void 0 : requestData.page) && (requestData === null || requestData === void 0 ? void 0 : requestData.page) > 0 ? new Date() : "",
            },
        });
        let liveNewsDataList = LiveNewsDTO(liveNewsData.data.listResponse);
        return liveNewsDataList;
    }
}
